import { render, staticRenderFns } from "./paymentorder.vue?vue&type=template&id=23f5824e&scoped=true"
import script from "./paymentorder.vue?vue&type=script&lang=js"
export * from "./paymentorder.vue?vue&type=script&lang=js"
import style0 from "./paymentorder.vue?vue&type=style&index=0&id=23f5824e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f5824e",
  null
  
)

export default component.exports